import { SidebarMenuItem } from '../models';

/**
 * Sekcje CV pogrupowane w kategorie — wyświetlane jako children "Moje CV"
 */
const CV_SECTIONS: SidebarMenuItem[] = [
    {
        label: 'cv.sidebar.mainData',
        isCategory: true,
        children: [
            { label: 'cv.sidebar.header', icon: 'pi pi-id-card', route: '/cv/header' },
            { label: 'cv.sidebar.skills', icon: 'pi pi-bolt', route: '/cv/skills' },
        ],
    },
    {
        label: 'cv.sidebar.careerEducation',
        isCategory: true,
        children: [
            { label: 'cv.sidebar.experience', icon: 'pi pi-briefcase', route: '/cv/experience' },
            { label: 'cv.sidebar.projects', icon: 'pi pi-folder-open', route: '/cv/projects' },
            { label: 'cv.sidebar.education', icon: 'pi pi-graduation-cap', route: '/cv/education' },
            { label: 'cv.sidebar.languages', icon: 'pi pi-globe', route: '/cv/languages' },
        ],
    },
    {
        label: 'cv.sidebar.privateData',
        isCategory: true,
        children: [
            { label: 'cv.sidebar.personalData', icon: 'pi pi-user', route: '/cv/personal' },
            { label: 'cv.sidebar.links', icon: 'pi pi-link', route: '/cv/links' },
        ],
    },
    {
        label: 'cv.sidebar.additional',
        isCategory: true,
        children: [
            { label: 'cv.sidebar.softSkills', icon: 'pi pi-heart-fill', route: '/cv/soft-skills' },
            { label: 'cv.sidebar.certificates', icon: 'pi pi-verified', route: '/cv/certificates' },
            { label: 'cv.sidebar.achievements', icon: 'pi pi-trophy', route: '/cv/achievements' },
            { label: 'cv.sidebar.references', icon: 'pi pi-comments', route: '/cv/references' },
            { label: 'cv.sidebar.externalSources', icon: 'pi pi-external-link', route: '/cv/external-sources' },
        ],
    },
];

/**
 * Wspólne elementy menu — dostępne dla obu typów kont.
 * Chat został przeniesiony do topbara (ikona z badge), więc nie ma go w sidebarze.
 */
const COMMON_MENU_ITEMS: SidebarMenuItem[] = [
    {
        label: 'layout.sidebar.menu.dashboard',
        icon: 'pi pi-home',
        route: '/dashboard/overview',
        active: true
    },
    {
        label: 'layout.sidebar.menu.settings',
        icon: 'pi pi-cog',
        route: '/settings',
        active: true
    }
];

/**
 * Elementy menu specyficzne dla kandydata
 */
const CANDIDATE_MENU_ITEMS: SidebarMenuItem[] = [
    {
        label: 'layout.sidebar.menu.my-cv',
        icon: 'pi pi-file',
        route: '/cv',
        expanded: false,
        children: CV_SECTIONS,
    },
    {
        label: 'layout.sidebar.menu.browse-offers',
        icon: 'pi pi-briefcase',
        route: '/browse-offers',
        active: true
    },
    {
        label: 'layout.sidebar.menu.my-applications',
        icon: 'pi pi-list-check',
        route: '/my-applications',
        active: true
    },
    {
        // „Dostęp i zgody" = jeden ekran z zakładkami (Prośby o dostęp / Moje zgody).
        // Dawne dwie pozycje (access-requests + active-access) scalone w jeden wpis;
        // trasa /access-requests/active-access żyje dalej jako deep-link do zakładki zgód.
        label: 'layout.sidebar.menu.access-consents',
        icon: 'pi pi-shield',
        route: '/access-requests',
        active: true
    },
    {
        label: 'layout.sidebar.menu.interviews',
        icon: 'pi pi-video',
        route: '/interviews',
        active: true
    },
    // {
    //     label: 'layout.sidebar.menu.ai-assistant',
    //     icon: 'pi pi-sparkles',
    //     route: '/content-generator',
    //     active: true
    // },
    {
        label: 'layout.sidebar.menu.tasks',
        icon: 'pi pi-check-square',
        route: '/tasks',
        active: true
    },
];

/**
 * Elementy menu specyficzne dla firmy — uporządkowane wg flow rekrutera:
 * Szukaj (sourcing) → Pula (CRM) → Rekrutacje (hub) → Oferty → Profil.
 * Powiązane powierzchnie zgrupowane pod rozwijanymi pozycjami zamiast luźnych
 * wpisów top-level (12 pozycji → 6), żeby ograniczyć szum.
 */
const COMPANY_MENU_ITEMS: SidebarMenuItem[] = [
    {
        label: 'layout.sidebar.menu.candidate-search',
        icon: 'pi pi-search',
        route: '/candidates',
        active: true
    },
    {
        // Pula = CRM kandydatów (jak prototyp): jeden płaski ekran z wewnętrznymi
        // zakładkami statusu (Odsłonięci / Oczekujący / Obserwowani). Dawne
        // sub-pozycje Ulubieni + Prośby o dostęp są wchłonięte przez te zakładki;
        // ich trasy żyją dalej (back-compat / deep-link), ale nie ma ich w menu.
        label: 'layout.sidebar.menu.talentPool',
        icon: 'pi pi-users',
        route: '/talent-pool',
        active: true
    },
    {
        // Rekrutacje = hub; Aplikacje (inbox) i Rozmowy żyją w kontekście rekrutacji.
        label: 'layout.sidebar.menu.recruitment-pipeline',
        icon: 'pi pi-sitemap',
        route: '/recruitment-pipeline',
        expanded: false,
        children: [
            {
                // Tablica kanban = główny ekran rekrutacji (/recruitment-pipeline).
                // Jawny wpis, bo klik w rodzica z dziećmi nawiguje do PIERWSZEGO
                // dziecka — bez tej pozycji tablica była nieosiągalna z menu.
                label: 'layout.sidebar.menu.recruitment-board',
                icon: 'pi pi-th-large',
                route: '/recruitment-pipeline',
                active: true
            },
            {
                label: 'layout.sidebar.menu.applications',
                icon: 'pi pi-list-check',
                route: '/applications/inbox',
                active: true
            },
            {
                label: 'layout.sidebar.menu.interviews',
                icon: 'pi pi-video',
                route: '/interviews',
                active: true
            },
        ],
    },
    {
        label: 'layout.sidebar.menu.job-offers',
        icon: 'pi pi-briefcase',
        route: '/job-offers',
        active: true
    },
    {
        // Jeden cel „konfiguracja firmy": profil publiczny + ustawienia konta.
        // (Scalenie pól dublujących się między dwoma backendami = osobna decyzja.)
        label: 'layout.sidebar.menu.companySettings',
        icon: 'pi pi-cog',
        route: '/company-profile',
        expanded: false,
        children: [
            {
                label: 'layout.sidebar.menu.company-profile',
                icon: 'pi pi-building',
                route: '/company-profile',
                active: true
            },
            {
                label: 'layout.sidebar.menu.accountSettings',
                icon: 'pi pi-sliders-h',
                route: '/settings',
                active: true
            },
        ],
    },
];

/**
 * Statyczne elementy menu — domyślne (kandydat) dla wstecznej kompatybilności
 */
export const STATIC_MENU_ITEMS: SidebarMenuItem[] = getMenuForAccountType('candidate');

/**
 * Zwraca elementy menu na podstawie typu konta
 */
export function getMenuForAccountType(accountType: 'candidate' | 'company'): SidebarMenuItem[] {
    const [dashboard, settings] = [COMMON_MENU_ITEMS[0], COMMON_MENU_ITEMS[1]];

    if (accountType === 'company') {
        // Ustawienia są już w grupie „Ustawienia firmy" w COMPANY_MENU_ITEMS,
        // więc NIE dopinamy ich ponownie na końcu.
        return [dashboard, ...COMPANY_MENU_ITEMS];
    }

    return [
        dashboard,
        ...CANDIDATE_MENU_ITEMS,
        settings,
    ];
}

/**
 * Konfiguracja domyślnych ikon dla sekcji CV
 */
export const MENU_ICONS = {
  cv: 'pi pi-file',
  section: 'pi pi-list',
  skill: 'pi pi-bolt',
  academy: 'pi pi-book',
  project: 'pi pi-folder',
  child: 'pi pi-file'
} as const;
